// Users.jsx
import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getUsers } from '../../actions';
import Loader from './../../components/Loader';
import { adminCreateUser, searchUser } from './../../actions/user.actions';
import { MainContainer } from '../MainContainer';
import RenderUsers from './RenderUsers';
import RenderModalContent from './RenderModalContent';
import PaginationComponent from '../../components/PaginationComponent';
import { setPageNumberUsers, setPageSizeUsers } from '../../reducers/user.reducer';
import CreateUserModal from './CreateUserModal';

const Users = () => {
    const [userDetailModal, setUserDetailModal] = useState(false);
    const [typeModal, setTypeModal] = useState("");
    const [currentId, setCurrentId] = useState(null);
    const [showCreate, setShowCreate] = useState(false);

    const {
        users,
        userDetails,
        loading,
        pageSize,
        pageNumber,
        totalAll,
        totalPages,
    } = useSelector((state) => state.user);

    const dispatch = useDispatch();
    const mainTitleRef = useRef(null);

    const handleCloseUserDetailsModal = () => {
        setUserDetailModal(false);
        setCurrentId(null);
        setTypeModal("");
    };

    const showUserDetailsModal = (userId, typeM) => {
        setTypeModal(typeM);
        setCurrentId(userId);
        setUserDetailModal(true);
    };

    const renderMainContent = () => (
        <>
            <RenderUsers
                users={users}
                showUserDetailsModal={showUserDetailsModal}
                pageNumber={pageNumber}
                pageSize={pageSize}
            />
            <PaginationComponent
                dispatchAction
                totalAll={totalAll}
                pageSize={pageSize}
                setPageNumber={setPageNumberUsers}
                pageNumber={pageNumber}
                totalPages={totalPages}
            />
        </>
    );

    const openCreate = () => setShowCreate(true);
    const closeCreate = () => setShowCreate(false);

    const onCreateSubmit = async (form) => {
        const res = await dispatch(adminCreateUser(form));
        if (res?.tempPassword) {
            alert(`Временный пароль: ${res.tempPassword}`);
        }
        closeCreate();
    };

    return (
        <MainContainer
            handleShow={openCreate}
            buttonText="Создать нового юзера"
            typeSort="user"
            search={searchUser}
            get={getUsers}
            title={"Все пользователи"}
            noneSelectUpdatedPictures
            setPageNumber={setPageNumberUsers}
            setPageSize={setPageSizeUsers}
            pageNumber={pageNumber}
            pageSize={pageSize}
        >
            {/* ИСПРАВЛЕНИЕ: Больше не убиваем компоненты при загрузке, предотвращая скачки и потерю стейта пагинации */}
            {loading && <Loader />}
            <div style={{ display: loading ? 'none' : 'block' }}>
                {renderMainContent()}
            </div>

            <RenderModalContent
                typeModal={typeModal}
                currentId={currentId}
                userDetails={userDetails}
                setTypeModal={setTypeModal}
                userDetailModal={userDetailModal}
                handleCloseUserDetailsModal={handleCloseUserDetailsModal}
            />
            <CreateUserModal
                show={showCreate}
                handleClose={closeCreate}
                onSubmit={onCreateSubmit}
            />
        </MainContainer>
    );
};

export default Users;